/* eslint-disable @typescript-eslint/no-unused-vars */
// TODO: TaiOla - Add remaining nav links
import { Datasets, LCTOnlyDatasets } from "../../constants/enums"
import {
    DEMAND_COMPLIANCE_STATUS_ID_AWAITING_ASSESSMENT,
    GEN_COMPLIANCE_STATUS_ID_AWAITING_ASSESSMENT,
} from "../../constants/generalConstants"
import {
    EVAC_AMEND_DEVICE_NAV_LINK,
    EVAC_CONTINUE_DEVICE_AMENDMENT_DRAFT_NAV_LINK,
    EVAC_CONTINUE_DEVICE_VERSION_DRAFT_NAV_LINK,
    EVAC_NEW_VERSION_NAV_LINK,
    EVDC_AMEND_DEVICE_NAV_LINK,
    EVDC_CONTINUE_DEVICE_AMENDMENT_DRAFT_NAV_LINK,
    EVDC_CONTINUE_DEVICE_VERSION_DRAFT_NAV_LINK,
    EVDC_NEW_VERSION_NAV_LINK,
    HP_AMEND_DEVICE_NAV_LINK,
    HP_CONTINUE_DEVICE_AMENDMENT_DRAFT_NAV_LINK,
    HP_CONTINUE_DEVICE_VERSION_DRAFT_NAV_LINK,
    HP_NEW_VERSION_NAV_LINK,
    TTR_AMEND_DEVICE_NAV_LINK,
    TTR_CONTINUE_DEVICE_AMENDMENT_DRAFT_NAV_LINK,
    TTR_CONTINUE_DEVICE_VERSION_DRAFT_NAV_LINK,
    TTR_NEW_VERSION_NAV_LINK,
} from "../../router/routes"
import * as routes from "../../router/routes"

const amendDeviceNavLinkMap: Record<Datasets, (deviceRef: string) => string> = {
    EVAC: EVAC_AMEND_DEVICE_NAV_LINK,
    EVDC: EVDC_AMEND_DEVICE_NAV_LINK,
    HP: HP_AMEND_DEVICE_NAV_LINK,
    EVAC_DRAFT: (deviceRef: string) => "",
    EVDC_DRAFT: (deviceRef: string) => "",
    HP_DRAFT: (deviceRef: string) => "",
    TTR_DRAFT: (deviceRef: string) => "",
    TTR: TTR_AMEND_DEVICE_NAV_LINK,
}

const continueDraftAmendmentNavLinkMap: Record<
    Datasets,
    (deviceRef: string) => string
> = {
    EVAC: (deviceRef: string) => "",
    EVAC_DRAFT: EVAC_CONTINUE_DEVICE_AMENDMENT_DRAFT_NAV_LINK,
    EVDC: (deviceRef: string) => "",
    EVDC_DRAFT: EVDC_CONTINUE_DEVICE_AMENDMENT_DRAFT_NAV_LINK,
    HP: (deviceRef: string) => "",
    HP_DRAFT: HP_CONTINUE_DEVICE_AMENDMENT_DRAFT_NAV_LINK,
    TTR_DRAFT: TTR_CONTINUE_DEVICE_AMENDMENT_DRAFT_NAV_LINK,
    TTR: (deviceRef: string) => "",
}

const continueDraftversionNavLinkMap: Record<
    Datasets,
    (deviceRef: string) => string
> = {
    EVAC: (deviceRef: string) => "",
    EVAC_DRAFT: EVAC_CONTINUE_DEVICE_VERSION_DRAFT_NAV_LINK,
    EVDC: (deviceRef: string) => "",
    EVDC_DRAFT: EVDC_CONTINUE_DEVICE_VERSION_DRAFT_NAV_LINK,
    HP: (deviceRef: string) => "",
    HP_DRAFT: HP_CONTINUE_DEVICE_VERSION_DRAFT_NAV_LINK,
    TTR_DRAFT: TTR_CONTINUE_DEVICE_VERSION_DRAFT_NAV_LINK,
    TTR: (deviceRef: string) => "",
}

const newVersionNavLinkMap: Record<Datasets, (deviceRef: string) => string> = {
    EVAC: EVAC_NEW_VERSION_NAV_LINK,
    EVAC_DRAFT: (deviceRef: string) => "",
    EVDC: EVDC_NEW_VERSION_NAV_LINK,
    EVDC_DRAFT: (deviceRef: string) => "",
    HP: HP_NEW_VERSION_NAV_LINK,
    HP_DRAFT: (deviceRef: string) => "",
    TTR_DRAFT: (deviceRef: string) => "",
    TTR: TTR_NEW_VERSION_NAV_LINK,
}

export const getAmendDeviceUrl = (
    dataset: Datasets,
    deviceRef: string
): string => amendDeviceNavLinkMap[dataset](deviceRef)

export const getContinueDraftAmendmentUrl = (
    dataset: Datasets,
    deviceRef: string
): string => continueDraftAmendmentNavLinkMap[dataset](deviceRef)

export const getContinueDraftversionUrl = (
    dataset: Datasets,
    deviceRef: string
): string => continueDraftversionNavLinkMap[dataset](deviceRef)

export const getNewVersionUrl = (
    dataset: Datasets,
    deviceRef: string
): string => newVersionNavLinkMap[dataset](deviceRef)

export const HP_TO_ASSESS = `${routes.DEMAND_DEVICE_SEARCH_BASE}/${LCTOnlyDatasets.HP}?${DEMAND_COMPLIANCE_STATUS_ID_AWAITING_ASSESSMENT}`

export const GEN_DEVICE_TO_ASSESS = `${routes.GEN_DEVICE_SEARCH}/?${GEN_COMPLIANCE_STATUS_ID_AWAITING_ASSESSMENT}`
